import axios, { AxiosResponse } from "axios";
import { LogisticsData } from "../@types/logistics";
const BASE_BUSINESS = "https://imwengine-wa-prod-san.azurewebsites.net/SodaStream/BusinessOrderQuotation?token=y5Fmxkv1KV5Tn_o0VlyfnUzmzdrAjIANAzqIkGBm6KfVwNzv9NlMEzVFJuhqupfNEyVy_GS5ZXA-jSF0WfYIr0bK1roIuoVg_-8RZ4pFZ_Bw2pBnXsEddS9Ez14561mIMwhaWY30ghHAL5ebjC1YdefuTSY4Mekj4X4z_83Yq9ypOtqs27DDspc9rvObfOqAa2XMXBUYWH98lI_Z7x-LcSuKj8iKjtZO4k69zzlhaJ5bvLqjGUf4IHP2-_nWplCfMomIxzzrHOg0b1iAIcV22EF96FDvMOPL8hte73LUCLgMnaf5Ax-mzFmazhCVY0rNhIbK7fXcb5AJ7M9EnEX-ZQ";
const BASE_RESIDENTIAL = "https://imwengine-wa-prod-san.azurewebsites.net/SodaStream/ResidentialOrderQuotation?token=y5Fmxkv1KV5Tn_o0VlyfnUzmzdrAjIANAzqIkGBm6KfVwNzv9NlMEzVFJuhqupfNEyVy_GS5ZXA-jSF0WfYIr0bK1roIuoVg_-8RZ4pFZ_Bw2pBnXsEddS9Ez14561mIMwhaWY30ghHAL5ebjC1YdefuTSY4Mekj4X4z_83Yq9ypOtqs27DDspc9rvObfOqAa2XMXBUYWH98lI_Z7x-LcSuKj8iKjtZO4k69zzlhaJ5bvLqjGUf4IHP2-_nWplCfMomIxzzrHOg0b1iAIcV22EF96FDvMOPL8hte73LUCLgMnaf5Ax-mzFmazhCVY0rNhIbK7fXcb5AJ7M9EnEX-ZQ";
const token = "y5Fmxkv1KV5Tn_o0VlyfnUzmzdrAjIANAzqIkGBm6KfVwNzv9NlMEzVFJuhqupfNEyVy_GS5ZXA-jSF0WfYIr0bK1roIuoVg_-8RZ4pFZ_Bw2pBnXsEddS9Ez14561mIMwhaWY30ghHAL5ebjC1YdefuTSY4Mekj4X4z_83Yq9ypOtqs27DDspc9rvObfOqAa2XMXBUYWH98lI_Z7x-LcSuKj8iKjtZO4k69zzlhaJ5bvLqjGUf4IHP2-_nWplCfMomIxzzrHOg0b1iAIcV22EF96FDvMOPL8hte73LUCLgMnaf5Ax-mzFmazhCVY0rNhIbK7fXcb5AJ7M9EnEX-ZQ";
// const BASE_URL = "https://sodastreamapi.azurewebsites.net/logistics";


class LogisticsService {
  getEndpointByPropertyType(propertyType: string): string {

    return propertyType === "Business" ? BASE_BUSINESS : BASE_RESIDENTIAL;
  }

  async createLogistics(
    logisticsData: LogisticsData
  ): Promise<{ data: LogisticsData | null; error: string | null }> {
    try {
  
      const endpoint = this.getEndpointByPropertyType(logisticsData.destination.propertyType);
      
      const response: AxiosResponse<LogisticsData> = await axios.post(
        endpoint,
        logisticsData
      );
      
      if (response.status >= 200 && response.status < 300) {
        const createdLogistics: LogisticsData = response.data;

        return { data: createdLogistics, error: null };
      } else {
        const error = `Error creating logistics - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error creating logistics:", error.message);
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      }
      return { data: null, error: error.message };
    }
  }

  async acceptQuote(
    acceptQuote: string
  ): Promise<{ data: string | null; error: string | null }> {
    try {
      const response: AxiosResponse<string> = await axios.post(
        `https://imwengine-wa-prod-san.azurewebsites.net/AcceptQuote?token=${token}&quoteId=${acceptQuote}`,
      );
      if (response.status >= 200 && response.status < 300) {
        const acceptQuoteResponse: string = response.data;

        return { data: acceptQuoteResponse, error: null };
      } else {
        const error = `Error creating quote - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error creating quote:", error.message);
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      }
      return { data: null, error: error.message };
    }
  }
}

const logisticsServiceInstance = new LogisticsService();
export default logisticsServiceInstance;

